<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>{{ $tc('general.n0') }}</th>
          <th>{{ $tc('form.image') }}</th>
          <th>{{ $tc('form.name') }}</th>
          <th v-if="showClubName">{{ $tc('club.club_name') }}</th>
          <th>{{ $tc('tournament.tournament_name') }}</th>
          <template v-if="$config.isWff">
            <th>{{ $tc('form.no_certificate_wff') }}</th>
            <th>{{ $tc('form.no_fudokan_passport') }}</th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="item.id">
          <td style="width: 30px">{{ index + 1 }}.</td>
          <td style="width: 80px">
            <div class="image">
              <img :src="$file('avatars', item.avatar)" style="width: 75px; height: 75px; object-fit: cover;" class="image" />
            </div>
          </td>
          <td>{{ item.firstName }} {{ item.lastName }}</td>
          <td v-if="showClubName">{{ item.club ? item.club.shortName : '' }}</td>
          <td>{{ getTournamentLabel(item) }}</td>
          <template v-if="$config.isWff">
            <td>{{ item.noCertificateWff }}</td>
            <td>{{ item.noRefereeCertificateWff }}</td>
            <td>{{ item.noFudokanPassport }}</td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: null
    },

    showClubName: {
      type: Boolean,
      default: false
    },

    tournament: {
      type: Object,
      default: null
    }
  },

  methods: {
    getTournamentLabel (item) {
      return item?.tournament?.name || item?.tournamentName || this.tournament?.name || ''
    }
  }
}
</script>
